import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { SPONSORS, EVENT } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { fadeUp, stagger, viewportOnce } from "../../lib/motion";
import { useLang } from "../../i18n/LanguageContext";

export const Sponsors = () => {
  const { t } = useLang();
  const s = t.sponsors;
  const waLink = EVENT.whatsapp;

  return (
    <section id="sponsors" data-testid="sponsors-section" className="relative overflow-hidden bg-ink-900 py-24 md:py-28">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[500px] -translate-x-1/2 rounded-full bg-gold-primary/8 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} subtitle={s.subtitle} testid="sponsors-heading" />

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4"
        >
          {SPONSORS.map((name) => (
            <motion.div
              key={name}
              variants={fadeUp}
              data-testid={`sponsor-${name.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "")}`}
              className="group flex min-h-[110px] flex-col items-center justify-center rounded-2xl border border-white/10 bg-ink-700/40 p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-gold-light/40"
            >
              <Sparkles className="mb-3 h-4 w-4 text-gold-light/60 transition-colors group-hover:text-gold-light" />
              <span className="font-display text-xl font-medium leading-tight text-white/90 transition-colors group-hover:text-gold-gradient">
                {name}
              </span>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-12 text-center">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="become-sponsor-btn"
            className="inline-flex items-center gap-2 rounded-full border border-gold-light/30 px-7 py-3.5 text-sm font-medium text-gold-light transition-colors hover:bg-gold-light/10"
          >
            <Sparkles className="h-4 w-4" />
            {s.cta}
          </a>
        </div>
      </div>
    </section>
  );
};
